module.exports = __webpack_public_path__ + "img/right-arrow.173620e5.svg";